import {
  useGetAdvisorSessionsQuery,
  useGetAdvisorSessionQuery
} from "../../../../../../redux/queries"
import AdvisorEmptyState from "../../../../advisor-empty-state"
import AdvisorSkeleton from "./advisor-skeleton"
import ConversationsTable from "./conversations-table"

interface Props {
  subscriptionId: string
  leadName: string
}

const EngagementAdvisorSection = ({ subscriptionId, leadName }: Props) => {
  const { data: sessionsPage, isLoading: isLoadingSessions } =
    useGetAdvisorSessionsQuery({ page: 1, limit: 100 })

  const session = sessionsPage?.conversations?.find(
    s => s.subscriptionId === subscriptionId
  )

  const { data: sessionDetail, isLoading: isLoadingDetail } =
    useGetAdvisorSessionQuery(session?._id ?? "", {
      skip: !session?._id
    })

  const isLoading = isLoadingSessions || (!!session && isLoadingDetail)
  const threads = sessionDetail?.threads ?? []

  if (isLoading) return <AdvisorSkeleton />

  if (!session)
    return (
      <AdvisorEmptyState description="When this lead interacts with the AI Advisor, their conversations will appear here." />
    )

  return (
    <div className="space-y-4">
      <ConversationsTable threads={threads} sessionId={session._id} />
    </div>
  )
}

export default EngagementAdvisorSection
